module.exports = __webpack_public_path__ + "408fe98c25570ea5dccc409ffe98a6a2.jpg";